export default __webpack_public_path__ + "4c8bee1c4298f201b915611ab0619906.svg";